<template>
    <div>

        <form @submit.prevent="submitForm()" @keydown="form.errors.clear($event.target.name)">

            <fieldset>
                <div class="form__legend">Základní údaje</div>

                <div class="form__row">
                    <label class="form--required">Titulek</label>
                    <div class="form__controls">
                        <input type="text" name="title" v-model="form.title">
                        <div class="form__error" v-html="form.errors.get('title')"></div>
                    </div>
                </div>

                <div class="form__row">
                    <label>Popis</label>
                    <div class="form__controls">
                        <textarea rows="4" name="descr" v-model="form.descr"></textarea>
                        <div class="form__error" v-html="form.errors.get('descr')"></div>
                    </div>
                </div>

                <div class="form__row">
                    <label class="form--required">Kapacita</label>
                    <div class="form__controls">
                        <input type="number" class="!w-32 text-right" name="capacity" v-model="form.capacity" @focus="form.errors.clear('capacity')">
                        <input type="text" class="!w-64" v-if="form.capacity > 1" name="unit" v-model="form.unit" maxlength="20" placeholder="jednotek zdroje">
                        <div class="form__error" v-html="form.errors.get('capacity')"></div>
                    </div>
                </div>

                <div class="-mt-2 mb-3">
                    <label class="reset form__controls--no-label">
                        <input type="checkbox" class="form__checkbox" :value="true" v-model="form.accepts_guests">
                        povolit k rezervaci přidávat hosty
                    </label>
                </div>

                <div class="form__row">
                    <label>ID terminálu</label>
                    <div class="form__controls">
                        <input type="text" name="terminal_id" v-model="form.terminal_id">
                        <div class="form__error" v-if="form.errors.get('terminal_id')" v-html="form.errors.get('terminal_id')"></div>
                        <div class="form__help" v-else>terminál musí být zadán i u podzdrojů pokud je u zdroje</div>

                    </div>
                </div>

                <div class="form__row">
                    <label class="form--required">Rezervace min.</label>
                    <div class="form__controls">
                        <input type="number" class="!w-32 mr-4 text-right" name="register_days_before" v-model="form.register_days_before" @focus="form.errors.clear('register_days_before')">
                        dní předem
                        <div class="form__error" v-html="form.errors.get('register_days_before')"></div>
                    </div>
                </div>

                <div class="form__row">
                    <label class="form--required">Zrušení min.</label>
                    <div class="form__controls">
                        <input type="number" class="!w-32 mr-4 text-right" name="cancel_days_before" v-model="form.cancel_days_before" @focus="form.errors.clear('cancel_days_before')">
                        dní předem
                        <div class="form__error" v-html="form.errors.get('cancel_days_before')"></div>
                    </div>
                </div>

                <div class="form__row">
                    <label class="form--required">Řazení</label>
                    <div class="form__controls">
                        <input type="number" class="!w-32 mr-4 text-right" name="order" v-model="form.order" @focus="form.errors.clear('order')">
                        <div class="form__error" v-html="form.errors.get('order')"></div>
                    </div>
                </div>

                <div class="form__row">
                    <label>Kategorie</label>
                    <div class="form__controls">
                        <select v-model="form.category_slug">
                            <option value="">------</option>
                            <option v-for="category in categories"
                                :key="category.item_slug"
                                :value="category.item_slug"
                                v-text="category.title"
                            ></option>
                        </select>
                    </div>
                </div>

            </fieldset>

            <fieldset>
                <div class="form__legend">Podzdroje</div>
                <div v-if="resource.hasParents" class="text-center italic text-sm text-muted">
                    zdroj může mít podzdroje jen když sám není pozdrojem
                </div>
                <ResourceFormSubresources
                    v-else
                    v-model="form.childResourcesIds"
                    :resource="resource"
                    :available-child-resources="availableChildResources"
                />
            </fieldset>

            <fieldset>
                <div class="form__legend">Oprávnění</div>
                <div>
                    <label>
                        <input type="checkbox" class="form__checkbox" :value="true" v-model="form.requiresPermissionToReserve">
                        povolit rezervaci tohoto zdroje jen pro vybrané skupiny uživatelů
                    </label>
                </div>
                <div v-if="form.requiresPermissionToReserve" class="mt-5 ml-10">
                    <label v-for="role in allRoles" :key="role.name" class="block text-left">
                        <input type="checkbox" class="form__checkbox" :value="role.name" v-model="form.availableForRoleNames">
                        {{ role.title }}
                    </label>
                </div>
            </fieldset>

            <fieldset>
                <div class="form__legend">Štítky</div>
                <ResourceFormTags
                    v-model="form.tagNames"
                    :resource="resource"
                    :all-tags="allTags"
                />
            </fieldset>

            <fieldset>
                <div class="form__legend">Schvalovatelé a správci zdroje</div>
                <div v-if="allApprovers.length === 0" class="text-center italic text-sm text-muted">
                    nemůžete vybrat schvalovatele, protože žádný uživatel v systému nemá roli Schvalovatel nebo Správce zdroje
                </div>
                <ResourceFormApprovers
                    v-else
                    v-model="form.approvers"
                    :resource="resource"
                    :all-approvers="allApprovers"
                />
                <div v-if="form.approvers.length" class="mt-4">
                    <input type="checkbox" class="form__checkbox" :checked="autoAcceptCheckboxChecked" @click="toggleAutoAccept">
                    automaticky schválit po
                    <input class="!w-16 mx-2" type="number" v-model="form.auto_accept_after_days">
                    dnech od registrace
                </div>
            </fieldset>

            <div class="Card">
                <div class="Card__title">Dostupnost</div>
                <div class="form__error" v-html="form.errors.get('openSlots')"></div>
                <ResourceFormCalendar class="h-[75vh]"
                    :resource="resource"
                    @changed="form.errors.clear()"/>
            </div>

            <fieldset>
                <div class="form__legend">Synchronizace do Google kalenářů</div>

                <div class="form__row">
                    <label>ID kalenářů</label>
                    <div class="form__controls">
                        <textarea rows="4" name="google_calendar_ids" v-model="form.google_calendar_ids"></textarea>
                        <div class="form__error" v-html="form.errors.get('google_calendar_ids')"></div>
                    </div>
                </div>
            </fieldset>

            <div class="form__buttons">
                <a :href="returnUrl" class="btn">
                    <icon name="x" />
                    Zrušit</a>
                <btn class="btn--primary" type="submit" :loading="sending" :disabled="form.errors.any()">
                    Uložit
                    <icon name="chevron-right" />
                </btn>
            </div>

        </form>

    </div>
</template>

<script>
import Form from '@/utils/Form';
import ResourceFormTags from './Tags';
import ResourceFormApprovers from './Approvers';
import ResourceFormSubresources from './Subresources';
import ResourceFormCalendar from './Calendar';

export default {
    components: {
        ResourceFormTags,
        ResourceFormSubresources,
        ResourceFormApprovers,
        ResourceFormCalendar,
    },
    props: {
        endpoint: {
            type: String,
            required: true
        },
        method: {
            type: String,
            default: 'post'
        },
        categories: {
            required: true
        },
        resource: {
            type: Object,
            default: () => ({
                capacity: 1,
                accepts_guests: false,
                register_days_before: 1,
                cancel_days_before: 1,
                order: 0,
                approvers: [],
                auto_accept_after_days: 0,
                tagNames: [],
                childResources: [],
                requiresPermissionToReserve: false,
                availableForRoleNames: []
            })
        },
        availableChildResources: {
            type: Array,
            required: true
        },
        allApprovers: {
            type: Array,
            required: true
        },
        allTags: {
            type: Array,
            default: () => [],
        }
    },

    data() {
        return {
            loaded: false,
            sending: false,
            returnUrl: '/resources',
            allRoles: [],

            form: new Form([
                'category_slug',
                'title',
                'descr',
                'capacity',
                'unit',
                'accepts_guests',
                'terminal_id',
                'register_days_before',
                'cancel_days_before',
                'order',
                'openSlots',
                'tagNames',
                'approvers',
                'auto_accept_after_days',
                'childResourcesIds',
                'requiresPermissionToReserve',
                'availableForRoleNames',
                'google_calendar_ids',
            ], this.resource)
        }
    },
    computed: {
        autoAcceptCheckboxChecked() {
            return !! parseInt(this.form.auto_accept_after_days);
        }
    },

    methods: {

        fetchRoles() {
            return axios.get(url('/roles?filter[editable]=true'))
                .then(result => {
                    this.allRoles = result.data;
                });
        },

        toggleAutoAccept() {
            this.form.auto_accept_after_days = this.autoAcceptCheckboxChecked
                ? 0
                : 5;
        },

        submitForm() {

            this.sending = true;

            this.form.openSlots = this.$store.openSlots;

            this.form[this.method](this.endpoint)

                .then(response => {
                    this.sending = false;
                    Notify.swal({
                        icon: 'success',
                        title: 'Uloženo',
                        timer: 2000
                    }).then(() => {
                        window.location.assign(this.returnUrl);
                    });
                })

                .catch(errors => {
                    this.sending = false;

                    // other than validation error
                    if (errors.status !== 422) {
                        console.log(errors);
                        alert('Chyba při odesílání formuláře');
                    }
                });
        }
    },

    mounted() {
        this.fetchRoles();
    }
}
</script>
